import { NetSuiteConnectRequestSchema } from '@vy/api-definition';
import type { oz } from '@vy/utils';

export const NetSuiteRegisterFormSchema = NetSuiteConnectRequestSchema;

export type NetSuiteRegisterFormValues = oz.infer<typeof NetSuiteRegisterFormSchema>;
